import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {DatePipe} from '@angular/common';

declare const $: any;

@Component({
    selector: 'app-question-date-of-birth',
    templateUrl: './question-date-of-birth.component.html',
    styleUrls: ['./question-date-of-birth.component.scss'],
    standalone: false
})
export class QuestionDateOfBirthComponent implements OnInit {

  @Input() question: Question;
  @Input() birthDate: any;
  @Input() birthMonth: any;
  @Input() birthYear: any;
  @Input() value: string;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<any>();
  months = [
    'January',
    'February',
    'March', 'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    if (this.value) {
      const date = new Date(this.value);
      this.birthDate = date.getDate();
      this.birthMonth = this.datePipe.transform(date, 'MMMM');
      this.birthYear = date.getFullYear();
    }
    if (this.question && this.question?.answer) {
      const date = new Date(this.question.answer);
      this.birthDate = date.getDate();
      this.birthMonth = this.datePipe.transform(date, 'MMMM');
      this.birthYear = date.getFullYear();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.value = changes?.value?.currentValue;
    if (this.value) {
      const date = new Date(this.value);
      this.birthDate = date.getDate();
      this.birthMonth = this.datePipe.transform(date, 'MMMM');
      this.birthYear = date.getFullYear();
    }
  }
  dropdownChange(event): void {
    if (event) {
      this.birthMonth = event;
    }
    this.submitAnswer();
  }

  inputChange(): void {
    this.submitAnswer();
  }

  // catches out-of-range days (e.g. 48 January, 30 February) that new Date(string) would
  // otherwise silently roll over or turn into an Invalid Date that DatePipe formats as garbage
  isValidDate(): boolean {
    if (!this.birthDate || !this.birthMonth || !this.birthYear || this.birthYear.toString().length !== 4) {
      return false;
    }
    const monthIndex = this.months.indexOf(this.birthMonth);
    if (monthIndex === -1) { return false; }
    const date = new Date(+this.birthYear, monthIndex, +this.birthDate);
    if (date.getFullYear() !== +this.birthYear || date.getMonth() !== monthIndex || date.getDate() !== +this.birthDate) {
      return false;
    }
    // A date of birth can't be in the future.
    return date <= new Date();
  }

  submitAnswer(): void {
    const answer = this.isValidDate()
      ? this.datePipe.transform(new Date(+this.birthYear, this.months.indexOf(this.birthMonth), +this.birthDate), 'yyyy-MM-dd')
      : '';

    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }


}
